import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
var _excluded = ["style", "children", "className", "useResponsivePadding", "shadowVariant"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { forwardRef } from "react";
import classnames from "classnames";
import { makeStyles, RaiseColors, useTheme } from "componentLibrary";
import { jsx as _jsx } from "react/jsx-runtime";
var useStyles = function useStyles(shadowVariant) {
  var theme = useTheme();
  return makeStyles(function () {
    return {
      container: {
        borderRadius: 16,
        boxShadow: shadowVariant === "subtle" ? "0px 2px 8px 0px ".concat(RaiseColors.midnight, "0a") : "0px 0px 16px 0px ".concat(RaiseColors.midnight, "14"),
        backgroundColor: RaiseColors.neutral100
      },
      responsivePadding: _defineProperty(_defineProperty({
        padding: "16px"
      }, theme.breakpoints.up("smMd"), {
        padding: "24px"
      }), theme.breakpoints.up("lg"), {
        padding: "32px"
      })
    };
  });
};
var ShadowContainer = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var style = _ref.style,
    children = _ref.children,
    className = _ref.className,
    _ref$useResponsivePad = _ref.useResponsivePadding,
    useResponsivePadding = _ref$useResponsivePad === void 0 ? false : _ref$useResponsivePad,
    _ref$shadowVariant = _ref.shadowVariant,
    shadowVariant = _ref$shadowVariant === void 0 ? "default" : _ref$shadowVariant,
    props = _objectWithoutProperties(_ref, _excluded);
  var classes = useStyles(shadowVariant)();
  return /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({
    ref: ref,
    className: classnames(className, classes.container, _defineProperty({}, classes.responsivePadding, useResponsivePadding)),
    style: style
  }, props), {}, {
    children: children
  }));
});
export default ShadowContainer;